import { mobileMax, mobileXXLargeMax, laptopLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Fibrus from '@propertypal/shared/src/resources/logos/fibrus.svg';
import { FIBRUS_PINK } from '@propertypal/shared/src/styles/theme';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { SubHeading } from '../typography';

export const Container = styled.div`
  margin: 30px 0;
  padding: 20px 30px;
  max-width: 1280px;
  width: 100%;
  overflow: hidden;

  ${({ theme }) =>
    platform.type === 'propertypal'
      ? `
    background-color: ${theme.background};
    border: 2px solid ${theme.keyline};
    border-radius: 10px;
  `
      : `
    background-color: ${theme.backgroundLightest};
    border-radius: 5px;
  `}

  @media (${mobileXXLargeMax}) {
    padding: 20px 15px;
    margin: 15px 0;
  }
`;

export const Title = styled.h2`
  font-size: 18px;
  color: ${(props) => props.theme.textDark};
  font-weight: normal;
  flex: 1;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;
  margin: 30px 0;

  th {
    padding: 5px;
    font-size: 12px;
    font-weight: 600;
    color: ${(props) => props.theme.textDark};
    border-bottom: 1px solid #dedede;
    border-top: 1px solid #dedede;
  }

  th:first-child {
    padding: 10px 0;
    text-align: left;
  }

  td {
    border-bottom: 1px solid #dedede;
    text-align: center;
    padding: 8px;
    color: ${(props) => props.theme.textDark};
  }

  td:first-child {
    font-weight: bold;
    text-align: left;
    padding: 8px 0;
    min-width: 112px;
  }

  tr:last-child td {
    border-bottom: 0;
  }

  @media (${mobileXXLargeMax}) {
    margin: 15px 0;

    th {
      font-size: 10px;
    }

    th:first-child {
      padding: 5px 10px;
    }

    td {
      font-size: 14px;
    }

    td:first-child {
      padding: 26px 10px;
    }
  }

  @media (${mobileMax}) {
    width: calc(100% + 30px);
    margin-left: -15px;
  }
`;

export const FibrusLogo = styled(Fibrus)<{ w: number }>`
  width: 100%;
  max-width: ${(props) => props.w}px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  gap: 18px;

  @media (${mobileXXLargeMax}) {
    ${SubHeading} {
      display: none;
    }
  }
`;

export const FibrusHeading = styled.span`
  display: block;
`;

export const NoBroadbandBox = styled.div`
  background: linear-gradient(90deg, #56a445 0%, #2b88ad 100%);
  padding: 25px 32px;
  display: flex;
  margin: 30px 0;
  border-radius: 10px;
  justify-content: space-between;
  gap: 60px;

  @media (${mobileXXLargeMax}) {
    flex-direction: column;
    gap: 15px;

    .fibrus-desktop-icon {
      display: none !important;
    }
  }
`;

export const NoBroadbandContent = styled.div`
  display: flex;
  gap: 30px;
  margin-top: 15px;
  max-width: 640px;

  a {
    display: inline-block;
    margin-top: 15px;
    background-color: ${FIBRUS_PINK};
    padding: 15px 20px;
    border-radius: 30px;
    color: white;
    font-weight: bold;
  }
`;

export const InterestFormBox = styled.div`
  background: linear-gradient(90deg, #56a445 0%, #2b88ad 100%);
  padding: 25px 30px;
  margin: 10px -30px 25px;
`;

export const InterestFormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
`;

export const InterestFormTitle = styled.h3`
  color: ${({ theme }) => theme.white};
  font-size: 24px;
  margin: 0;
  font-family: ${platform.headingFont};
`;

export const InterestFormLogo = styled.img`
  width: 100%;
  max-width: 122px;
`;

export const InterestForm = styled.form`
  margin-top: 20px;
`;

export const InterestFormInputs = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;

  .pp-input-error {
    box-shadow: inset 0 0 0 2px ${FIBRUS_PINK};
  }

  .pp-validation-error {
    background-color: ${FIBRUS_PINK};
  }

  @media (${laptopLargeMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > *:last-child {
      grid-column: 1 / -1;
    }
  }

  @media (${mobileXXLargeMax}) {
    grid-template-columns: 1fr;
  }
`;
